import React, { useMemo, useRef, useState } from 'react'

import { useDrag } from '@use-gesture/react';
import { useThree } from '@react-three/fiber';
import { useDispatch } from 'react-redux';
import debounce from 'lodash.debounce';

import * as actionCreator from '../../../../../action/index';
import { const_var, params } from '../../../../../redux/reducers/reducer';
import { controls } from '../../../../../redux/reducers/common/eventReducer';

import Legs from './Legs'
import Wall from './Wall'
import Roof from './Roof'
import Storage from './Storage'
import DoorWindows from '../../../DoorWindows';
import WallName from './WallName';
import GableRightLeanToMeasurement from '../../../Measurements/LeanToMeasurement/GableRightLeanToMeasurement';
import { wallNameArrForValid } from '../../../../../utils/Validation';

const GableRightLean = ({ overlapTrussArr, setOverlapTrussArr, normalMap, envMap }) => {
    const ref = useRef();
    const get = useThree((state) => state.get)
    const dispatch = useDispatch();
    const [isDragable, setIsDragable] = useState(true);
    const [position, setPosition] = useState(0);
    const [startPosition, setStartPosition] = useState(0);
    const [dragging, setDragging] = useState(false);
    const [previousLength, setPreviousLength] = useState(0);
    const [leanToTrussPosArr, setLeanToTrussPosArr] = useState([]);

    const camPosX = const_var.camera?.position?.x;
    
    let offset = 1
    if(camPosX >= 0) offset = 1;
    else if(camPosX < 0) offset = -1;

    const limit = useMemo(() => {
        return {
            min: -params.p_d / 2 + params.leanR_p_w / 2,
            max: params.p_d / 2 - params.leanR_p_w / 2
        }
    }, [params.p_d, params.leanR_p_w])

    const bind = useDrag(
        ({ down, delta, first, event, movement: [mx, my] }) => {
            if (controls.isCheckActiveTab === 'doorwindow' ? (const_var.focusedSection === "gablerightlean" && params.activeWall !== "G_R_L_F_S_W") : true) {
                event.stopPropagation();
            }

            if (controls.isCheckActiveTab === 'buildsizes_right' ) {
                if (first) {
                    setStartPosition(position);
                }

                if (down === true) {
                    const distance = (const_var.controls!=undefined && const_var.controls.getDistance!=undefined)?const_var.controls.getDistance([0, 0, 0]):[0, 0, 0];
                    const_var.controls.enableRotate = false;
                    get().gl.domElement.style.cursor = 'move';
                    
                    let distanceValue = distance - params.p_d / 2;

                    if (isDragable) {
                        const nextPosition = startPosition + (-mx * offset) * (distanceValue / 1000);
                        if (nextPosition < limit.min) {
                            setPosition(limit.min)
                        } else if (nextPosition > limit.max) {
                            setPosition(limit.max)
                        } else {
                            setPosition(nextPosition);
                        } 
                        setDragging(true)
                    }
                } else {
                    const_var.controls.enableRotate = true;
                    get().gl.domElement.style.cursor = 'auto'

                    dispatch(actionCreator.changeLeanDragState(true));
                    setIsDragable(false);
                    
                    let isFind = false;
                    const doorsArray = [...const_var.newDoorsArray]
                    const cbDoorsArr = doorsArray.filter(item => wallNameArrForValid.find(subArr => subArr.includes('c_b_r_w')).filter(element => element.includes('c_b_')).includes(item.userData.wallName));
                    const leanDoorsArr = doorsArray.filter(item => item.userData.wallName === 'G_R_L_B_W');

                    if (cbDoorsArr.length > 0 && leanDoorsArr.length > 0) {
                        cbDoorsArr.forEach(item_st => {
                            const tempChangedDoorPosX = -item_st.positionX - (position - startPosition);

                            leanDoorsArr.forEach(item_lean => {
                                if (Math.abs(item_lean.positionX - tempChangedDoorPosX) < item_lean.width / 2 + item_st.width / 2 + const_var.componentDistance &&
                                    Math.abs(item_lean.positionY - item_st.positionY) < item_lean.height / 2 + item_st.height / 2 + const_var.componentDistance)
                                {
                                    isFind = true;
                                }
                            })
                        })
                    }

                    if (isFind) {
                        dispatch(actionCreator.handleShowAlertBox("notAllowNewPosition"));
                        setPosition(startPosition)
                        setStartPosition(startPosition)
                    } else {
                        const updatedNewDoorArr = const_var.newDoorsArray.map((item) => {
                            if (item.userData.wallName === 'G_R_L_F_W' || item.userData.wallName === 'G_R_L_B_W' || item.userData.wallName === 'G_R_L_F_S_W' || item.userData.wallName === 'G_R_L_B_S_W') {
                                return {
                                    ...item,
                                    positionX: (item.userData.wallName === 'G_R_L_B_W' || item.userData.wallName === 'G_R_L_B_S_W') ? item.positionX + (position - startPosition) : item.positionX - (position - startPosition),
                                    minLimitX: item.minLimitX - (position - startPosition),
                                    maxLimitX: item.maxLimitX - (position - startPosition)

                                }
                            }
                            return item;
                        })
                        if (JSON.stringify(const_var.newDoorsArray) !== JSON.stringify(updatedNewDoorArr)) {
                            dispatch(actionCreator.updateDoorWindowsArray(updatedNewDoorArr, true));
                        }
                    
                        dispatch(actionCreator.updateLeanToPosition('right', position))
                        if (position === limit.min) {
                            dispatch(actionCreator.changeLeantoPosition({event: 3, value: 'right'}))
                        } else if (position === limit.max) {
                            dispatch(actionCreator.changeLeantoPosition({event: 2, value: 'right'}))
                        } else if (position === 0) {
                            dispatch(actionCreator.changeLeantoPosition({event: 1, value: 'right'}))
                        } else {
                            dispatch(actionCreator.changeLeantoPosition({event: 4, value: 'right'}))
                        }

                        setPreviousLength(`${params.p_d}${params.leanR_p_w}`)

                        setStartPosition(position);
                        setDragging(false)

                        if(position !== startPosition && !dragging){
                            setPosition(startPosition)
                        } else {
                            setPosition(position)
                        }
                    }

                    debounceForDragLean()
                }
            }
        },
        { pointerEvents: true }
    );

    const prvLeanR_p_d = useMemo(() => {
        const prvLeanR_p_d = ref.current
        ref.current = params.leanR_p_d;
        
        return prvLeanR_p_d    
    }, [params.leanR_p_d])

    useMemo(() => {
        let pos = 0;

        if( Number(params.leantoAlignmentRight) === 1 ) pos = 0;
        else if( Number(params.leantoAlignmentRight) === 2 ) pos = params.p_d / 2 - params.leanR_p_w / 2;
        else if( Number(params.leantoAlignmentRight) === 3 ) pos = -params.p_d / 2 + params.leanR_p_w / 2;
        else if( Number(params.leantoAlignmentRight) === 4){
            if (previousLength !== `${params.p_d}${params.leanR_p_w}` && !params.apiCallAfterEdit) {
                if (position <= limit.min) {
                    pos = limit.min;
                    dispatch(actionCreator.changeLeantoPosition({event: 3, value: 'right'}))
                } else if (position >= limit.max) {
                    pos = limit.max;
                    dispatch(actionCreator.changeLeantoPosition({event: 2, value: 'right'}))
                } else if (position === 0 || params.leanR_p_w === params.p_d) {
                    pos = 0;
                    dispatch(actionCreator.changeLeantoPosition({event: 1, value: 'right'}))
                } else pos = position;
            } else pos = position;
        }
        
        if(params.add_right_lean && !params.apiCallAfterEdit && !dragging && pos !== startPosition) {
            const sideArrayRight = const_var.newDoorsArray.filter((item) => item.userData.wallName === 'G_R_L_F_W' || item.userData.wallName === 'G_R_L_F_S_W');
            sideArrayRight.forEach((item) => {
                dispatch(actionCreator.updateDoorWindowPosition(item.uniqueId, item.positionX - (pos - startPosition)));
            })

            const sideArrayLeft = const_var.newDoorsArray.filter((item) => item.userData.wallName === 'G_R_L_B_W' || item.userData.wallName === 'G_R_L_B_S_W');
            sideArrayLeft.forEach((item) => {
                dispatch(actionCreator.updateDoorWindowPosition(item.uniqueId, item.positionX + (pos - startPosition)));
            })
 
            setStartPosition(pos);
            setPosition(pos);
            dispatch(actionCreator.updateLeanToPosition('right', pos))
        }
    }, [Number(params.leantoAlignmentRight), params.leanR_p_w, params.add_right_lean, params.p_d, params.leanR_p_pos, params.apiCallAfterEdit])

    const debounceForDragLean = debounce(() => {
        setTimeout(() => {
            setIsDragable(true);
            clearTimeout();
        }, [250]);
    }, [250]);

    useMemo(() => {
        if(params.add_right_lean) {
            dispatch(actionCreator.setLeanToTrussPosInfo({
                data: { rightLeanTo: leanToTrussPosArr }
            }));
        } else {
            dispatch(actionCreator.setLeanToTrussPosInfo({
                data: { rightLeanTo: [] }
            }));
        }
    }, [leanToTrussPosArr, params.add_right_lean]);
    
    useMemo(() => {
        dispatch(actionCreator.changeLeanDragState(false));
        setPosition(params.leanR_p_pos);
        setStartPosition(params.leanR_p_pos);
    }, [params.leanR_p_pos, Number(params.leantoAlignmentRight)])

    useMemo(() => {
        dispatch(actionCreator.updateGableBackWall("right"));
    }, [params.p_r_w]);

    return (
        <group 
            name='gableRightLean'
            position={[0, 0, position]}
            {...bind()}
        >
            <Roof />
            <Wall />
            <Legs normalMap={normalMap} envMap={envMap} setLeanToTrussPosArr={setLeanToTrussPosArr}/>

            {params.add_storage_check_right && <Storage />}
            <group position={dragging ? undefined : [0, 0, -position]}>
                <DoorWindows overlapTrussArr={overlapTrussArr} setOverlapTrussArr={setOverlapTrussArr} section='gableRightLean' />
            </group>
            {const_var.callMesure && 
                <>
                    <WallName />
                    <GableRightLeanToMeasurement color='#2F7CBF' />
                </>
            }
        </group>
    )
}

export default GableRightLean